import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=0868aade&scoped=true&"
import script from "./FontSelect.vue?vue&type=script&lang=js&"
export * from "./FontSelect.vue?vue&type=script&lang=js&"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=0868aade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868aade",
  null
  
)

export default component.exports